import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import RadioButtonDefecto from "../../../../../Common/Components/RadioButtonDefecto2";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const Correspondencia = ({ data, selectRadio }) => {
    const { GET_ATLAS_TIPO_COMUNICACION } = data;
    const acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Env" + acentoLetraIminuscula + "o de Correspondencia - Opci" + acentoLetraOminuscula + "n por Defecto"}</label>

                {GET_ATLAS_TIPO_COMUNICACION.map(item => {
                    const referencia = `GATC-${item.Id}`;

                    return (
                        <RadioButtonDefecto
                            key={item.Id}
                            nombre={"GATC"}
                            descripcion={item.Descripcion}
                            valor={item.Id}
                            checked={item.Checked}
                            referencia={referencia}
                            disabled={item.Activo == true ? false : true}
                            selectRadio={(valor) => selectRadio("GET_ATLAS_TIPO_COMUNICACION", valor)} />
                    );
                })}

                {data.ERROR_PRODUCT["seleccionoCorrespondencia"] == false
                    && <label className="error">{"Debe seleccionar al menos un tipo de comunicaci" + acentoLetraOminuscula + "n."}</label>}
            </div>
        </div>
    );
}

export default Correspondencia;